export default __webpack_public_path__ + "74df7f5d238f1e7a59177ddedf399fcd.svg";